var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelegate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3271,
    y1: 256.0004,
    x2: 498.6724,
    y2: 256.0004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.4,104.9H220.3V63.2c0-3.3-2.1-6.1-5.2-7.1l-96-29.8c-1.4-0.4-3-0.4-4.4,0l-96,29.8 c-3.1,1-5.2,3.8-5.2,7.1v49.1c0,61.9,28,120.7,74.4,160v145.2c0,15.6,12.7,28.3,28.3,28.3h33.5v32.8c0,4.1,3.3,7.4,7.4,7.4h55.8 c4.1,0,7.4-3.3,7.4-7.4v-32.8h145.9v32.8c0,4.1,3.3,7.4,7.4,7.4h55.8c4.1,0,7.4-3.3,7.4-7.4v-32.8h33.5c15.6,0,28.3-12.7,28.3-28.3 V133.2C498.7,117.6,486,104.9,470.4,104.9z M440.6,242.6v-49.1H457v49.1H440.6z M441.4,178.6h-8.2c-4.1,0-7.4,3.3-7.4,7.4v64 c0,4.1,3.3,7.4,7.4,7.4h8.2v35.7h-8.2c-4.1,0-7.4,3.3-7.4,7.4v64c0,4.1,3.3,7.4,7.4,7.4h8.2v19.4h-297v-118 c35.6-29.5,60.1-69.3,70.4-113.5h226.6V178.6z M440.6,357.2v-49.1H457v49.1H440.6z M28.2,112.3V68.7l88.6-27.5l88.6,27.5v43.6 c0,66-33,126.6-88.6,163.1C62,240.1,28.2,178,28.2,112.3z M205.4,471.1h-40.9v-25.3h40.9V471.1z M422,471.1h-40.9v-25.3H422V471.1z  M483.8,417.5c0,7.4-6,13.4-13.4,13.4H116.1c-7.4,0-13.4-6-13.4-13.4V283.9c3.3,2.3,6.8,4.6,10.3,6.8c1.2,0.7,2.5,1.1,3.9,1.1 c1.4,0,2.7-0.4,3.9-1.1c3-1.9,5.8-3.8,8.7-5.8v114.2c0,4.1,3.3,7.4,7.4,7.4h311.9c4.1,0,7.4-3.3,7.4-7.4v-26.8h8.2 c4.1,0,7.4-3.3,7.4-7.4v-64c0-4.1-3.3-7.4-7.4-7.4h-8.2v-35.7h8.2c4.1,0,7.4-3.3,7.4-7.4v-64c0-4.1-3.3-7.4-7.4-7.4h-8.2v-26.1 c0-4.1-3.3-7.4-7.4-7.4H217.6c1.3-8.3,2.1-16.8,2.4-25.3h250.4c7.4,0,13.4,6,13.4,13.4V417.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.5037,
    y1: 275.3509,
    x2: 363.9393,
    y2: 275.3509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.2,346.1c39,0,70.7-31.7,70.7-70.7s-31.7-70.7-70.7-70.7s-70.7,31.7-70.7,70.7S254.2,346.1,293.2,346.1z  M237.9,282.8h25.8c0.7,2.9,1.9,5.6,3.4,8.1l-18.2,18.2C243.1,301.6,239.3,292.6,237.9,282.8z M293.2,259.7c8.6,0,15.6,7,15.6,15.6 s-7,15.6-15.6,15.6s-15.6-7-15.6-15.6S284.6,259.7,293.2,259.7z M277.6,301.5c2.5,1.5,5.2,2.7,8.1,3.4v25.8 c-9.8-1.3-18.8-5.2-26.4-10.9L277.6,301.5z M300.7,304.8c2.9-0.7,5.6-1.9,8.1-3.4l18.2,18.2c-7.5,5.8-16.5,9.6-26.4,10.9V304.8z  M308.8,249.3c-2.5-1.5-5.2-2.7-8.1-3.4v-25.8c9.8,1.3,18.8,5.2,26.4,10.9L308.8,249.3z M285.8,245.9c-2.9,0.7-5.6,1.9-8.1,3.4 L259.4,231c7.5-5.8,16.5-9.6,26.4-10.9V245.9z M337.6,309.2l-18.2-18.2c1.5-2.5,2.7-5.2,3.4-8.1h25.8 C347.2,292.6,343.3,301.6,337.6,309.2z M348.5,267.9h-25.8c-0.7-2.9-1.9-5.6-3.4-8.1l18.2-18.2 C343.3,249.1,347.2,258.1,348.5,267.9z M248.9,241.5l18.2,18.2c-1.5,2.5-2.7,5.2-3.4,8.1h-25.8 C239.3,258.1,243.1,249.1,248.9,241.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.0019,
    y1: 144.6832,
    x2: 175.6589,
    y2: 144.6832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96,188.3c1.9,0,3.8-0.7,5.3-2.2l74.4-74.4l-10.5-10.5l-69.2,69.2l-27.5-26.9L58,154.1l32.8,32 C92.2,187.6,94.1,188.3,96,188.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegate);
export default __webpack_public_path__ + "static/media/delegate.84ea78ff989ef1bf92ef51518baee9ba.svg";
export { ForwardRef as ReactComponent };